export default function TransitionScreen() {
  return (
    <section className="flex items-center justify-center min-h-screen px-6 py-12">
      <div className="text-center">
        <p className="text-2xl text-gray-700 mb-4 animate-pulse">
          Patterns emerging…
        </p>
        <div className="w-24 h-0.5 bg-[#e87a02] mx-auto animate-[pulse_1s_ease-in-out_infinite]" />
      </div>
    </section>
  );
}